import { memo } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import "./IconAccount.scss";
import DotNotification from "app/pages/.shared/DotNotification/DotNotification";

const IconAccount = ({ userIsConnected, className, svgClassName, size = 20, ...props }) => {
	return (
		<div className={classNames("icon-account__wpr", className)}>
			{userIsConnected && <DotNotification />}

			<svg
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 20 20"
				fill="none"
				aria-hidden="true"
				focusable="false"
				className={classNames("icon-account__icon", svgClassName)}
				{...props}
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M13.9153 2.44027C13.9153 2.44028 13.9153 2.44027 13.9153 2.44027V2.44027ZM18.0598 6.58476C18.0597 6.58476 18.0598 6.58475 18.0598 6.58476V6.58476Z"
					fill="currentColor"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10 1.54166C5.05246 1.54166 1.04167 5.55245 1.04167 10.5C1.04167 15.4476 5.05246 19.4583 10 19.4583C14.9476 19.4583 18.9583 15.4476 18.9583 10.5C18.9583 9.79804 18.8776 9.11494 18.7249 8.45947C18.5722 7.804 18.3476 7.17617 18.0598 6.58476C17.9064 6.26975 17.7352 5.96509 17.5474 5.67207C16.8481 4.5812 15.9188 3.6519 14.8279 2.95264C14.5349 2.76482 14.2303 2.59358 13.9153 2.44027C13.5156 2.24576 13.0993 2.08011 12.6691 1.94601C11.9852 1.73285 11.2661 1.59944 10.5228 1.55667C10.3498 1.54671 10.1755 1.54166 10 1.54166ZM5.05034 15.0994C5.79218 13.8012 7.17278 13 8.66801 13H11.332C12.8273 13 14.2078 13.8012 14.9497 15.0994L15.2463 15.6185C13.9152 16.9826 12.0565 17.8296 10 17.8296C7.94351 17.8296 6.08482 16.9826 4.75373 15.6185L5.05034 15.0994ZM12.5 8.83333C12.5 10.2141 11.3808 11.3333 10 11.3333C8.61926 11.3333 7.50001 10.2141 7.50001 8.83333C7.50001 7.45262 8.61926 6.33333 10 6.33333C11.3808 6.33333 12.5 7.45262 12.5 8.83333Z"
					fill="currentColor"
				/>
			</svg>
		</div>
	);
};

IconAccount.propTypes = {
	userIsConnected: PropTypes.bool,
	className: PropTypes.string,
	svgClassName: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default memo(IconAccount);
